import { UserStore } from "../stores/user.store";
import { filterNilValue, Query } from "@datorama/akita";
import { distinctUntilChanged, Observable, shareReplay } from "rxjs";
import { User as HeaderUser } from "@husbanken/designsystem-angular-header-v2";
import { inject, Injectable } from "@angular/core";
import { User } from "../models/user.model";
import { HbCapitalizeWordsIfAllCapsPipe } from "@husbanken/designsystem-angular-core";

@Injectable({ providedIn: "root" })
export class UserQuery extends Query<User> {
  public readonly headerUser$: Observable<HeaderUser>;

  constructor() {
    super(inject(UserStore));

    this.headerUser$ = this.select(state => ({
      personNavn: new HbCapitalizeWordsIfAllCapsPipe().transform(state.name),
      personNummer: state.pid,
    })).pipe(filterNilValue(), distinctUntilChanged(), shareReplay({ refCount: true, bufferSize: 1 }));
  }

  public get orgnr(): string {
    return this.getValue().organization_number;
  }
}
